/* eslint-disable jira/filename-case */
import { createSelector, type OutputSelector } from 'reselect';
import type { State } from '../types.tsx';

const getBlueprintsFlow = (state: State) => state.blueprints;

export const getBlueprintsFlowTourDismissed: OutputSelector<
	State,
	boolean | undefined,
	(res: { tourDismissed?: boolean }) => boolean | undefined
> = createSelector(getBlueprintsFlow, (flow) => {
	return flow.tourDismissed;
});
